export const BRAND = {
  name: "Starke United Global Resources LLP",
  short: "Starke United",
  tagline: "Global Solutions | Proven Results",
  logo: "/images/logo.jpg",
  email: "ceo@starkegroup.co.in",
  phone: "+91 87960 28172",
  landline: "+91-011-47009571 / 72",
  fax: "+91-011-47009570",
  whatsapp: "918796028172",
  headOffice: { label: "Head Office", city: "New Delhi, India", lines: ["I 68, Lajpat Nagar 1", "Second Floor", "New Delhi — 110024", "India"] },
  factory: { label: "Manufacturing Unit", city: "Wankaner, Morbi, Gujarat, India", lines: ["Survey No 106/2, Matel Road", "Near Classy Sanitaryware", "Behind Symbosa Granito", "Wankaner, Morbi — 363622", "Gujarat, India"] },
};

export const REGIONS = [
  { code: "EU", name: "Europe", markets: "Italy · Spain · Germany · Poland · UK" },
  { code: "IN", name: "India", markets: "Pan-India dealer network" },
  { code: "SEA", name: "South East Asia", markets: "Vietnam · Thailand · Malaysia · Indonesia" },
  { code: "AU", name: "Australia", markets: "Sydney · Melbourne · Perth" },
  { code: "RU", name: "Russia", markets: "Moscow · St. Petersburg · CIS" },
  { code: "ME", name: "Middle East", markets: "UAE · Saudi Arabia · Qatar · Oman" },
  { code: "LATAM", name: "Latin America", markets: "Mexico · Brazil · Chile · Colombia" },
];

export const TESTIMONIALS = [
  { name: "Ahmed Al Mansoori", role: "Distributor · Dubai, UAE", quote: "Consistent shade, consistent calibre, consistent shipping. Starke United understands that for an importer, reliability is the product." },
  { name: "Sophie Laurent", role: "Architect · Lyon, France", quote: "Their 1200 x 1800 slabs let us bookmatch an entire hotel lobby with almost no visible joints. The vein continuity is remarkable." },
  { name: "Daniel Whitford", role: "Project Buyer · Melbourne, Australia", quote: "From sample approval to container loading, the export team kept us informed at every step. Documentation was flawless." },
  { name: "Mateus Oliveira", role: "Retail Chain · São Paulo, Brazil", quote: "The Velvet+ matt range has become our best-selling premium line. Customers touch it and they are sold." },
];

export const MANIFESTO = [
  { n: "01", title: "Crafted in India", text: "Our manufacturing unit sits in Morbi, Gujarat — the ceramic capital of India. Italian kilns, digital printing lines and inline calibration deliver slabs with tolerances measured in tenths of a millimetre." },
  { n: "02", title: "Directed from New Delhi", text: "From our head office in New Delhi we run export documentation, design curation and client relationships — one point of contact from sampling to shipment." },
  { n: "03", title: "Delivered to the world", text: "Europe, India, South East Asia, Australia, Russia, the Middle East and Latin America. Container-level logistics, region-specific certifications and shade-matched reorders." },
];

export const STATS = [
  { value: 22, suffix: "", label: "Surface finishes" },
  { value: 20, suffix: "", label: "Tile formats" },
  { value: 7, suffix: "", label: "Global regions" },
  { value: 3200, suffix: "mm", label: "Largest slab length" },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Corporate", children: [{ label: "Company Profile", to: "/#about" }, { label: "Infrastructure", to: "/#infrastructure" }] },
  { label: "Our Collection", mega: true },
  { label: "Across the Globe", to: "/#global" },
  { label: "E-Catalogue", to: "/#catalogues" },
  { label: "Information", children: [{ label: "Tiles Calculator", to: "/#calculator" }, { label: "Technical Specs", to: "/#infrastructure" }, { label: "Testimonials", to: "/#testimonials" }] },
  { label: "Contact Us", to: "/#contact" },
];
